// extracted by mini-css-extract-plugin
module.exports = {"service-box":"CardLayanan_service-box__KPzw6","visible":"CardLayanan_visible__WO29R"};